export class StoreConstants {
  public static readonly Base = {
    ModuleName: 'base',
    Getters: {},
    Actions: {},
    Mutations: {
      SetIsLoading: 'IS_LOADING'
    }
  };

  public static readonly CabinetConfiguration = {
    ModuleName: 'cabinetConfigurationStore',
    Getters: {
      CabinetConfigurationChange: 'cabinetConfigurationChange',
      IsConfigurationLoading: 'isConfigurationLoading',
      CabinetConfigurationLockHeldByCurrentSession: 'cabinetConfigurationLockHeldByCurrentSession',
      CabinetConfigurationSettings: 'cabinetConfigurationSettings',
      DocumentDateSetting: 'documentDateSetting',
      DocumentTypeStoringConfigurationSetting: 'documentTypeStoringConfigurationSetting',
      ReferenceStoringConfigurationSetting: 'referenceStoringConfigurationSetting',
      ReferenceSearchingConfigurationSetting: 'referenceSearchingConfigurationSetting',
      ListConfigurations: 'listConfigurations',
      CabinetConfigurationChangeId: 'cabinetConfigurationChangeId',
      IsLockedByCurrentSessionId: 'isLockedByCurrentSessionId',
      BypassConfigurationChangeLock: 'bypassConfigurationChangeLock'
    },
    Actions: {
      BeginChange: 'beginChange',
      EndChange: 'endChange',
      GetChangeWithErrorPage: 'getChangeWithErrorPage',
      GetCabinetConfigurationSettingsWithErrorPage: 'getCabinetConfigurationSettingsWithErrorPage',
      SetCabientConfigurationEnableEncryptionForNewCabinets: 'setCabientConfigurationEnableEncryptionForNewCabinets'
    },
    Mutations: {
      ...StoreConstants.Base.Mutations,
      SetCabinetConfigurationChange: 'SET_CABINET_CONFIGURATION_CHANGE',
      SetCabinetConfigurationSettings: 'SET_CABINET_CONFIGURATION_SETTINGS',
      SetCabinetConfigurationSettingsIsEncryptNewDocumentTypesEnabled: 'SET_CABINET_CONFIGURATION_SETTINGS_IS_ENCRYPT_NEW_DOCUMENT_TYPES_ENABLED'
    }
  };

  public static readonly ApplicationDirty = {
    ModuleName: 'applicationDirtyStore',
    Getters: {
      IsApplicationDirty: 'isApplicationDirty',
      IsApplicationDirtyOnAnotherTab: 'isApplicationDirtyOnAnotherTab',
      ShowApplicationDirtyModal: 'showApplicationDirtyModal',
      ApplicationDirtyRouteNavigatedTo: 'applicationDirtyRouteNavigatedTo'
    },
    Actions: {
      ResetApplicationDirtyState: 'resetApplicationDirtyState',
      SetApplicationDirty: 'setApplicationDirty',
      SetApplicationDirtyOnAnotherTab: 'setApplicationDirtyOnAnotherTab',
      SetShowApplicationDirtyModal: 'setShowApplicationDirtyModal',
      SetApplicationDirtyRouteNavigatedTo: 'setApplicationDirtyRouteNavigatedTo',
      SetApplicationDirtyOnModal: 'setApplicationDirtyOnModal'
    },
    Mutations: {
      ResetApplicationDirtyState: 'RESET_APPLICATION_DIRTY_STATE',
      SetApplicationDirty: 'SET_APPLICATION_DIRTY',
      SetApplicationDirtyOnAnotherTab: 'SET_APPLICATION_DIRTY_ON_ANOTHER_TAB',
      SetShowApplicationDirtyModal: 'SET_SHOW_APPLICATION_DIRTY_MODAL',
      SetApplicationDirtyRouteNavigateTo: 'SET_APPLICATION_DIRTY_ROUTE_NAVIGATED_TO',
      SetApplicationDirtyOnModal: 'SET_APPLICATION_DIRTY_ON_MODAL'
    }
  };

  public static readonly Configuration = {
    ModuleName: 'configurationStore',
    Getters: {
      ConfigurationTree: 'configurationTree',
      ExpandSelectedNodeOnMount: 'expandSelectedNodeOnMount'
    },
    Actions: {
      GetConfigurationTree: 'getConfigurationTree',
      SetSelectedNodeToExpandOnMount: 'setSelectedNodeToExpandOnMount',
      ResetSelectedNodeToExpandOnMount: 'resetSelectedNodeToExpandOnMount'
    },
    Mutations: {
      ...StoreConstants.Base.Mutations,
      SetTree: 'SET_TREE',
      SetSelectedNodeToExpandOnMount: 'SET_SELECTED_NODE_TO_EXPAND_ON_MOUNT',
      ResetSelectedNodeToExpandOnMount: 'RESET_SELECTED_NODE_TO_EXPAND_ON_MOUNT'
    }
  };

  public static readonly ConfigurationChange = {
    ModuleName: 'configurationChangeStore',
    Getters: {
      BypassConfigurationChangeLock: 'bypassConfigurationChangeLock',
      ConfigurationChange: 'configurationChange',
      ConfigurationChangeLock: 'configurationChangeLock',
      ConfigurationChangeLockedByCurrentSession: 'configurationChangeLockedByCurrentSession',
      ConfigurationChangeIsLoading: 'configurationChangeIsLoading'
    },
    Actions: {
      BeginChange: 'beginChange',
      EndChange: 'endChange',
      GetChangeWithErrorPage: 'getChangeWithErrorPage'
    },
    Mutations: {
      ...StoreConstants.Base.Mutations,
      SetConfigurationChange: 'SET_CONFIGURATION_CHANGE'
    }
  };

  public static readonly DocumentView = {
    ModuleName: 'documentViewStore',
    Getters: {
      RelatedDocumentBeingViewed: 'relatedDocumentBeingViewed',
      IsRelatedDocumentBeingViewed: 'isRelatedDocumentBeingViewed',
      Document: 'document',
      DocumentSearchModel: 'documentSearchModel',
      IsDeleting: 'isDeleting'
    },
    Actions: {
      SetRelatedDocumentBeingViewed: 'setRelatedDocumentBeingViewed'
    },
    Mutations: {
      ...StoreConstants.Base.Mutations
    }
  };

  public static readonly WorkflowJob = {
    ModuleName: 'workflowJobStore',
    Getters: {
      ActiveVerticalTab: 'activeVerticalTab',
      VerticalJobTabs: 'verticalJobTabs',
      WorkflowJob: 'workflowJob',
      WorkflowDataSource: 'workflowDataSource',
      WorkflowDataSourceField: 'workflowDataSourceField',
      JobTabState: 'jobTabState',
      WorkflowJobTabs: 'workflowJobTabs',
      IsTabProcessing: 'isTabProcessing',
      EntityLock: 'entityLock',
      HasWorkflowJobBeenNavigatedAwayFrom: 'hasWorkflowJobBeenNavigatedAwayFrom',
      IsWorkflowJobProcessed: 'isWorkflowJobProcessed',
      DocumentSearchModel: 'documentSearchModel'
    },
    Actions: {
      SetJobTabStateHidden: 'setJobTabStateHidden',
      SetIsTabProcessing: 'setIsTabProcessing',
      ReleaseWorkflowJobLock: 'releaseWorkflowJobLock',
      SetHasWorkflowJobBeenNavigatedAwayFrom: 'setHasWorkflowJobBeenNavigatedAwayFrom',
      SetIsWorkflowJobProcessed: 'setIsWorkflowJobProcessed',
      SetWorkflowDataSourceField: 'setWorkflowDataSourceField'
    },
    Mutations: {
      ...StoreConstants.Base.Mutations
    }
  };

  public static readonly UserPreferences = {
    ModuleName: 'userPreferencesStore',
    Getters: {
      SortOptions: 'sortOptions',
      PinSort: 'pinSort',
      FilterOptions: 'filterOptions',
      ColumnConfigurations: 'columnConfigurations',
      EmailToMe: 'emailToMe',
      SearchOptions: 'searchOptions',
      SearchPinFilter: 'searchPinFilter',
      SearchPinSort: 'searchPinSort',
      SearchSplitConfiguration: 'searchSplitConfiguration',
      PagesStoreMode: 'pagesStoreMode'
    },
    Actions: {
      SetSortOptions: 'setSortOptions',
      SetPinSort: 'setPinSort',
      SetFilterOptions: 'setFilterOptions',
      SetColumnConfigurations: 'setColumnConfigurations',
      SetEmailToMe: 'SetEmailToMe',
      SetIncludeDocumentContent: 'setIncludeDocumentContent',
      SetSearchOptions: 'setSearchOptions',
      SetSearchPinFilter: 'setSearchPinFilter',
      SetSearchPinSort: 'SetSearchPinSort',
      SetSearchSplitConfiguration: 'SetSearchSplitConfiguration',
      SetPagesStoreMode: 'setPagesStoreMode'
    },
    Mutations: {
      ...StoreConstants.Base.Mutations,
      SetSortOptions: 'SET_SORT_OPTIONS',
      SetPinSort: 'SET_PIN_SORT',
      SetFilterOptions: 'SET_FILTER_OPTIONS',
      SetColumnConfigurations: 'SET_COLUMN_CONFIGURATIONS',
      SetEmailToMe: 'SET_EMAIL_TO_ME',
      SetSearchOptions: 'SET_SEARCH_OPTIONS',
      SetSearchPinFilter: 'SET_SEARCH_PIN_FILTER',
      SetSearchPinSort: 'SET_SEARCH_PIN_SORT',
      SetSearchSplitConfiguration: 'SET_SEARCH_SPLIT_CONFIGURATION',
      SetIncludeDocumentContent: 'SET_INCLUDE_DOCUMENT_CONTENT',
      SetPagesStoreMode: 'SET_PAGES_STORE_MODE'
    }
  };

  public static readonly ListMaintenance = {
    ModuleName: 'listMaintenanceStore',
    Getters: {
      EntityLock: 'entityLock',
      ExtendingLock: 'extendingLock',
      Error: 'error'
    },
    Actions: {
      ExtendLock: 'extendLock',
      ReleaseBuiltInListLock: 'releaseBuiltInListLock',
      SetExtendingLock: 'setExtendingLock',
      SetComponentName: 'setComponentName',
      SetErrorModel: 'setErrorModel',
      SetIsDirty: 'setIsDirty',
      SetEntityLock: 'setEntityLock'
    },
    Mutations: {
      ...StoreConstants.Base.Mutations,
      ExtendListLock: 'EXTEND_LIST_LOCK',
      SetExtendingListLock: 'SET_EXTENDING_LIST_LOCK',
      ExpireListLock: 'EXPIRE_LIST_LOCK',
      SetComponentName: 'SET_COMPONENT_NAME',
      SetErrorModel: 'SET_ERROR_MODEL',
      SetEntityLock: 'SET_ENTITY_LOCK'
    }
  };

  public static readonly RelatedDocuments = {
    ModuleName: 'relatedDocumentsStore',
    Getters: {
      RelatedDocumentsModel: 'relatedDocumentsModel',
      IsLoading: 'isLoading'
    },
    Actions: {
      GetRelatedDocuments: 'getRelatedDocuments'
    },
    Mutations: {
      ...StoreConstants.Base.Mutations
    }
  };

  public static readonly User = {
    ModuleName: 'userStore',
    Getters: {
      CurrentUser: 'currentUser',
      PreviousRoute: 'previousRoute'
    }
  };

  public static readonly Search = {
    ModuleName: 'searchStore',
    Getters: {
      SearchCriteria: 'searchCriteria',
      SearchResults: 'searchResults'
    },
    Actions: {
      SetSearchCriteria: 'setSearchCriteria',
      SetSelectedItems: 'setSelectedItems',
      SetCurrentPage: 'setCurrentPage',
      SetItemsPerPage: 'setItemsPerPage',
      SetShowSorting: 'setShowSorting',
      SetShowFilters: 'setShowFilters',
      SetAppliedFilterOptions: 'setAppliedFilterOptions',
      SetAppliedSortOptions: 'setAppliedSortOptions',
      SetColumnOrders: 'setColumnOrders',
      SetSplitConfiguration: 'setSplitConfiguration',
      SetSearchResponse: 'setSearchResponse',
      SetUnsortedItems: 'setUnsortedItems',
      SetLastViewedDocument: 'setLastViewedDocument',
      UnloadSearchResults: 'unloadSearchResults',
      ResetSearchResults: 'resetSearchResults'
    },
    Mutations: {
      SetSearchCriteria: 'SET_SEARCH_CRITERIA',
      SetSelectedItems: 'SET_SELECTED_ITEMS',
      SetCurrentPage: 'SET_CURRENT_PAGE',
      SetItemsPerPage: 'SET_ITEMS_PER_PAGE',
      SetShowSorting: 'SET_SHOW_SORTING',
      SetShowFilters: 'SET_SHOW_FILTERS',
      SetAppliedFilterOptions: 'SET_APPLIED_FILTER_OPTIONS',
      SetAppliedSortOptions: 'SET_APPLIED_SORT_OPTIONS',
      SetColumnOrders: 'SET_COLUMN_ORDERS',
      SetSplitConfiguration: 'SET_SPLIT_CONFIGURATION',
      SetSearchResponse: 'SET_SEARCH_RESPONSE',
      SetUnsortedItems: 'SET_UNSORTED_ITEMS',
      SetLastViewedDocument: 'SET_LAST_VIEWED_DOCUMENT',
      UnloadSearchResults: 'UNLOAD_SEARCH_RESULTS',
      ResetSearchResults: 'RESET_SEARCH_RESULTS'
    }
  };

  public static readonly Oidc = {
    ModuleName: 'oidcStore',
    Getters: {
      OidcUser: 'oidcUser'
    }
  };
}
